module.exports = __webpack_public_path__ + "static/media/bi-dir-arrow.dcd6ca09.svg";